import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import {YandexWrapper} from './wrappers/YandexWrapper'
import {getSettings, YANDEX_METRIKA_ID} from './common'

const {name, version} = require('../package.json')
console.log(`${name} ${version}`)

ReactDOM.render(<YandexWrapper metrikaId={YANDEX_METRIKA_ID} />, document.getElementById('root'))

if (process.env.NODE_ENV !== 'development') {
    // TODO это нужно заменить на нативный кеш
    if (navigator && navigator.serviceWorker) {
        const swPromise = navigator.serviceWorker.register('sw.js', {
            scope: './',
        })
        if (swPromise && swPromise.then) {
            swPromise.then(reg => console.log('sw register:', reg.scope))
        }
    }
}

// @ts-ignore
window.__getSettings = getSettings
